import { signIn as nextAuthSignIn } from '#pplx/frontend/auth/signIn.js';
import { redirectToSignInError } from '#pplx/frontend/auth/utils.js';
import { clearPersistedCache } from '#pplx/frontend/react-query/queryClient.js';
import { clearServiceWorkerRuntimeCache } from '#pplx/frontend/workers/service-worker/utils/clearServiceWorkerRuntimeCache.js';
export async function signIn(provider, options = {}, authorizationParams) {
    const { redirectOnError = true, ...restOptions } = options;
    await clearPersistedCache();
    await clearServiceWorkerRuntimeCache();
    try {
        await nextAuthSignIn(provider, restOptions, authorizationParams);
    }
    catch (error) {
        if (redirectOnError) {
            redirectToSignInError();
        }
        else {
            throw error;
        }
    }
}
//# sourceMappingURL=signIn.js.map